import capifrance from './capifrance';
import lngDefault from './default';
import optimhome from './optimhome';

export default {
  default: lngDefault,
  capifrance,
  optimhome,
};
